import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useEffect, useState } from 'react';
import { isStaff } from '../../../common/typeAssertionFunctions';
import useAuthStore from '../../../datastore/useAuth';
import useLoyaltyPoints from '../../../datastore/useLoyaltyPoints';
import CustomerLoyaltyPointsHistoryModal from '../../../components/modal/CustomerLoyaltyPointsHistoryModal';
import { formatPaymentType, PaymentType } from '../../../common/enums';



export default function HeaderLoyaltyPoints() {
    const { currentUser } = useAuthStore()
    const { fetchLoyaltyPointsForCustomer, getAvailableBalance, loading } = useLoyaltyPoints()
    const [showHistory, setShowHistory] = useState(false)

    useEffect(() => {
        if (currentUser && !isStaff(currentUser)) {
            fetchLoyaltyPointsForCustomer(currentUser.id)
        }
    }, [currentUser, fetchLoyaltyPointsForCustomer])

    if (!currentUser || isStaff(currentUser) || !currentUser.isActive) {
        return (
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center', justifyContent: 'flex-end', flex: 1, paddingRight: 2, height: 30 }}></Stack>
        )
    }
    const loyaltyPointsBalance = getAvailableBalance()

    return (
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center', justifyContent: 'flex-end', flex: 1, paddingRight: 2, height: 30 }}>
            {
                loading ? [] : (
                    <Button color={loyaltyPointsBalance < 1 ? 'warning' : 'primary'} onClick={() => setShowHistory(true)} sx={{ textAlign: 'right', fontSize: '0.7rem' }}>{loyaltyPointsBalance} {formatPaymentType(PaymentType.LoyaltyPoints)}</Button>
                )
            }
            {
                showHistory && currentUser && !isStaff(currentUser) ? (
                    <CustomerLoyaltyPointsHistoryModal customer={currentUser} onClose={() => setShowHistory(false)} />
                ) : null
            }
        </Stack>
    )

}